import { render } from "./hidden-app-redirect.vue?vue&type=template&id=0041e3d0"
import script from "./hidden-app-redirect.vue?vue&type=script&lang=js"
export * from "./hidden-app-redirect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__